import React from 'react'
import { Helmet } from 'react-helmet'

import { isUnderTest } from '../Helpers/isUnderTest'
import { useHasConsent } from '../Hooks/useHasConsent/useHasConsent'

export const UET: React.FC<{}> = () => {
  const hasConsent = useHasConsent(['thirdparty'])
  const uetTagId = process.env.UET_TAG_ID
  if (isUnderTest()) return
  if (!hasConsent || !uetTagId) {
    return null
  }

  return (
    <Helmet>
      <script type={'text/javascript'}>
        {`(function (w, d, t, r, u) {
            var f, n, i;
            (w[u] = w[u] || []),
                (f = function () {
                var o = { ti: "${uetTagId}", enableAutoSpaTracking: true };
                (o.q = w[u]), (w[u] = new UET(o)), w[u].push("pageLoad");
                }),
                (n = d.createElement(t)),
                (n.src = r),
                (n.async = 1),
                (n.onload = n.onreadystatechange =
                function () {
                    var s = this.readyState;
                    (s && s !== "loaded" && s !== "complete") ||
                    (f(), (n.onload = n.onreadystatechange = null));
                }),
                (i = d.getElementsByTagName(t)[0]),
                i.parentNode.insertBefore(n, i);
            })(window, document, "script", "//bat.bing.com/bat.js", "uetq");`}
      </script>
    </Helmet>
  )
}
